import { gql } from '@apollo/client';
import NotificationMessageDTO from './fragments/notificationMessageDTO.fragment.notification';

export default gql`
  mutation archiveNotification($uuid: String!) @client {
    archiveNotification(input: { notificationUUID: $uuid }) {
      ...NotificationMessageDTO
    }
  }
  ${NotificationMessageDTO}
`;
